import apiFetch from '../apiFetch'

export default function (token, rating) {
  return apiFetch({ endPoint: `Rating/${rating.ratingId}`, method: 'DELETE', body: null, token: token })
}
